import { render, staticRenderFns } from "./productReturn.vue?vue&type=template&id=1e9e3281&scoped=true&"
import script from "./productReturn.vue?vue&type=script&lang=js&"
export * from "./productReturn.vue?vue&type=script&lang=js&"
import style0 from "./productReturn.vue?vue&type=style&index=0&id=1e9e3281&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9e3281",
  null
  
)

export default component.exports